<script>
    export let text = "Loading..."
</script>

<h4>{text}</h4>
<div class="progress">
    <div class="indeterminate"></div>
</div>